/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Keyboard from '../Keyboard/index';
import HiresCardOne from '../HiresCardOne/index';
import HiresCardTwo from '../HiresCardTwo/index';
import HiresCardThree from '../HiresCardThree/index';

import FiftyMbps from '../../images/HiresCard/50Mbps';
import EightyMbps from '../../images/HiresCard/80Mbps';
import HundredSixMbps from '../../images/HiresCard/160Mbps';
import TwoHundredMbps from '../../images/HiresCard/200Mbps';
import ThreeHundredFiftyMbps from '../../images/HiresCard/350Mbps';
import FiveHundredMbps from '../../images/HiresCard/500Mbps';
import ThousandMbps from '../../images/HiresCard/1000Mbps';
import UI from '../../images/ATC/ui.png';
import Wifi from '../../images/ATC/wifi.png';

import './styles.scss';

class HiresCards extends React.Component {
  render() {

  function plusButtonPosition () {
    const plusButton = document.getElementById('plus__button');
    const ariaExpanded = plusButton.getAttribute('aria-expanded');
    if (ariaExpanded === "false") {
      plusButton.classList.add('plus__button');
    } else {
      plusButton.classList.remove('plus__button');
    }
  }

    return (
      <div className="hires__cards__container">

        <div className="collapsible__hires__card">
          <button id="plus__button" className="btn btn-link minus__button" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded={true} aria-controls="collapseOne" onClick={plusButtonPosition}><span>-</span></button>
          <div className="accordion" id="accordionElement">
            <div className="card">
              <div className="card-header" id="headingOne">
                <img class="telephone" src={FiftyMbps} alt="Telephone" />
                <h2 className="mb-0 hires__card__text">+ 80 Canales + 50 Canales HD</h2>
                <button className="hires__card__button">lo quiero</button>
              </div>
              <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionElement">
                <div className="card-body">
                  <p>TELEFONÍA FIJA: Llamadas ilimitadas MEX / EUA / CAN / Incluye llamadas ilimitadas a celular</p>
                  <div className="info__container">
                    <div className="internet__content">
                      <img src={Wifi} atl="Wifi"></img>
                      <p>Conexión a Internet</p>
                    </div>
                    <div className="calls__container">
                      <img src={UI} atl="Soporte Técnico Telefonía"></img>
                      <div className="calls__content">
                        <p>Llamadas ilimitadas</p>
                        <div className="zone__container">
                          <p>Nacionales</p>
                          <p>|</p>
                          <p>A EUA y Canadá</p>
                          <p>|</p>
                          <p>A móviles</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <HiresCardOne
          icon = {FiftyMbps}
          text = "+ 80 Canales + 50 Canales HD"
        />
        <HiresCardOne
          icon = {EightyMbps}
          text = "+ 120 Canales + 90 Canales HD"
        />
        <HiresCardOne
          icon = {HundredSixMbps}
          text = "+ 120 Canales + 90 Canales HD"
        />
        <HiresCardOne
          icon = {TwoHundredMbps}
          text = "+ 120 Canales + 90 Canales HD"
        />
        <HiresCardTwo
          icon = {TwoHundredMbps}
          title = "XVIEW TOTAL 200"
          text = "+ 80 Canales + 50 Canales HD"
        />
        <HiresCardTwo
          icon = {ThreeHundredFiftyMbps}
          title = "XVIEW TOTAL 350"
          text = "+ 80 Canales + 50 Canales HD"
        />
        <HiresCardTwo
          icon = {FiveHundredMbps}
          title = "XVIEW TOTAL 500"
          text = "+ 80 Canales + 50 Canales HD"
        />
        <HiresCardTwo
          icon = {ThousandMbps}
          title = "XVIEW TOTAL 1GB"
          text = "+ 80 Canales + 50 Canales HD"
        />
        <Keyboard />
        <HiresCardThree
          text = "Hasta 50 Mbps de velocidad + Llamadas Ilimitadas"
        />
        <HiresCardThree
          text = "Hasta 100 Mbps de velocidad + Llamadas Ilimitadas"
        />
        <HiresCardThree
          text = "Hasta 200 Mbps de velocidad + Llamadas Ilimitadas"
        />
        <HiresCardThree
          text = "Hasta 350 Mbps de velocidad + Llamadas Ilimitadas"
        />
      </div>
    );
  }
}

export default HiresCards;
